import React from 'react';
import Layout from '../../../../components/Layout';
import ServicesLayout from '../../../../components/ServicesLayout';
import EditDistrict from './EditDistrict';
import StepClass from '../../../../classes/StepClass';
import stepperWrapper from '../../../../hocs/stepperWrapper';
import layoutWrapper from '../../../../hocs/layoutWrapper';

import { isAdminUser } from '../../../../lib/utils';

const title = 'Szczegóły urzędu';

export default {
  path: '/editDistrict/:teryt',
  async action(ctx) {
    const isAdmin = await isAdminUser(ctx);
    if (!isAdmin) {
      return { redirect: '/' };
    }
    const component = stepperWrapper(<EditDistrict title={title} {...ctx.params} />, [
      new StepClass('/admin', 'Admin'),
      new StepClass('/districts', 'Gminy'),
      new StepClass('/editDistrict', 'Edycja urzędu'),
    ]);

    return {
      title,
      chunk: 'editDistrict',
      component: layoutWrapper({ isAdmin }, component),
    };
  },
};



// WEBPACK FOOTER //
// src/routes/admin/districts/edit_district/index.js